import * as React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import useDrive from "../../hooks/useDrive";
import useNotification from "../../hooks/useNotification";
import FileService from "../../services/FileService";
import DriveService from "../../services/DriveService";
import { DRIVE_TYPES } from "../../config/appConst";

export default function FileRenameDialog() {
    const { renameRow, changeRenameRow, CurrentDrive, changeCurrentDrive } = useDrive();
    const { addNotification } = useNotification();

    const handleClose = () => changeRenameRow(null);

    const handleSubmit = async event => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const name = data.get('fileName');
        const { parent } = CurrentDrive;
        if (name) {
            let params = { file_name: parent + "/" + renameRow.Key, file_name_new: parent + "/" + name };
            if ((parent !== "/" && parent === "") || !parent) {
                params = { file_name: renameRow.Key, file_name_new: name };
            }
            params["driveType"] = CurrentDrive.driveType;
            await FileService.rename(params);
            addNotification({ type: "success", message: "File renamed successfully" });
            changeRenameRow(null);
            const drive = await DriveService.getFileTree(parent, CurrentDrive.driveType);
            if (CurrentDrive.driveType === DRIVE_TYPES.SHARED) {
                changeCurrentDrive({ parent, drive: {}, sharedDrive: drive, driveType: CurrentDrive.driveType });
            } else {
                changeCurrentDrive({ parent, drive });
            }
        }
    };

    return (
        <Dialog
            open={!!renameRow}
            onClose={handleClose}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: {
                    bgcolor: '#111328',
                    border: '1px solid rgba(255,255,255,0.08)',
                    borderRadius: 3,
                    boxShadow: '0 24px 60px rgba(0,0,0,0.6)',
                }
            }}
        >
            <form onSubmit={handleSubmit}>
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.5, pb: 1 }}>
                    <DriveFileRenameOutlineIcon sx={{ color: '#fff', fontSize: 20 }} />
                    <Typography sx={{ color: '#fff', fontWeight: 600, fontSize: 16, flex: 1 }}>
                        Rename File
                    </Typography>
                    <IconButton size="small" onClick={handleClose} sx={{ color: 'rgba(255,255,255,0.4)', '&:hover': { color: '#fff' } }}>
                        <CloseIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{ pt: 1, pb: 2 }}>
                    <TextField
                        name="fileName"
                        fullWidth
                        autoFocus
                        required
                        placeholder="Enter new name"
                        defaultValue={renameRow?.Key || ''}
                        variant="outlined"
                        sx={{
                            mt: 1,
                            '& .MuiOutlinedInput-root': {
                                color: '#fff',
                                borderRadius: 2,
                                bgcolor: 'rgba(255,255,255,0.04)',
                                '& fieldset': { borderColor: 'rgba(255,255,255,0.12)' },
                                '&:hover fieldset': { borderColor: '#fff' },
                                '&.Mui-focused fieldset': { borderColor: '#fff', borderWidth: 1 },
                            },
                            '& .MuiInputBase-input::placeholder': { color: 'rgba(255,255,255,0.3)', opacity: 1 },
                        }}
                    />
                </DialogContent>

                <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
                    <Button
                        onClick={handleClose}
                        sx={{
                            color: 'rgba(255,255,255,0.5)', textTransform: 'none', fontWeight: 500,
                            '&:hover': { color: '#fff', bgcolor: 'rgba(255,255,255,0.06)' },
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="submit"
                        variant="contained"
                        sx={{
                            textTransform: 'none', fontWeight: 600, px: 3, borderRadius: 2,
                            bgcolor: '#fff', color: '#111328',
                            '&:hover': { bgcolor: 'rgba(255,255,255,0.88)' },
                        }}
                    >
                        Rename
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}
